import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'

export const UPDATE_CLIP_FEEDBACK_TEXT = gql`
  mutation UpdateClipFeedbackTextMutation(
    $input: UpdateClipFeedbackTextInput!
  ) {
    updateClipFeedbackText(input: $input) {
      feedback {
        text
      }
    }
  }
`

const UpdateClipFeedbackText = ({ clipId, children }) => (
  <Mutation mutation={UPDATE_CLIP_FEEDBACK_TEXT}>
    {mutate =>
      children(text =>
        mutate({
          variables: { input: { clipId, text } },
          optimisticResponse: {
            updateClipFeedbackText: {
              __typename: 'Clip',
              feedback: { __typename: 'ClipFeedback', text }
            }
          }
        })
      )
    }
  </Mutation>
)

export default UpdateClipFeedbackText



// WEBPACK FOOTER //
// ./src/mutations/UpdateClipFeedbackText.js